
import Vue, { PropType } from 'vue';
import { RunnitUpload } from '@run-diffusion/shared';
import RunnitImage from '@/views/Runnits/RunnitImage.vue';

// Full-screen viewer for library uploads. Uploads carry no generation metadata,
// so there is nothing for RunnitImageInfoCarouselDialog to show alongside the
// image; this is the image on its own, with the same stepping affordances.
//
// The current upload is owned by the parent (same contract as the node run
// carousel) so the gallery stays the single source of truth for what is shown.
export default Vue.extend({
	name: 'UploadFullScreenDialog',
	props: {
		value: { type: Boolean, default: false },
		upload: { type: Object as PropType<RunnitUpload>, default: null },
		uploads: { type: Array as PropType<RunnitUpload[]>, default: () => [] },
	},
	data () {
		return {
			touchStartX: 0,
			touchEndX: 0,
		};
	},
	computed: {
		currentIndex (): number {
			if (!this.upload) return -1;
			return this.uploads.findIndex((upload: RunnitUpload) => upload && upload.id === this.upload.id);
		},
		hasPrev (): boolean {
			return this.currentIndex > 0;
		},
		hasNext (): boolean {
			return this.currentIndex > -1 && this.currentIndex < this.uploads.length - 1;
		},
	},
	created () {
		document.addEventListener('keydown', this.handleKeyDown);
	},
	destroyed () {
		document.removeEventListener('keydown', this.handleKeyDown);
	},
	methods: {
		close () {
			this.$emit('input', false);
		},
		onPrevClick () {
			if (!this.hasPrev) return;
			this.$emit('on-step', this.uploads[this.currentIndex - 1]);
		},
		onNextClick () {
			if (!this.hasNext) return;
			this.$emit('on-step', this.uploads[this.currentIndex + 1]);
		},
		// Escape is left to v-dialog's own handling so this does not double-fire
		// against it, or against a parent dialog when the gallery is nested.
		handleKeyDown (event: KeyboardEvent) {
			if (!this.value) return;

			switch (event.key) {
				case 'ArrowLeft':
					this.onPrevClick();
					break;
				case 'ArrowRight':
					this.onNextClick();
					break;
			}
		},
		handleTouchStart (event: TouchEvent) {
			this.touchStartX = event.changedTouches[0].screenX;
		},
		handleTouchEnd (event: TouchEvent) {
			this.touchEndX = event.changedTouches[0].screenX;
			this.handleSwipe();
		},
		// The stepper buttons are desktop-only, so swipe is the only way to step
		// on a phone.
		handleSwipe () {
			const swipeThreshold: number = 50;
			const swipeDistance: number = this.touchEndX - this.touchStartX;

			if (Math.abs(swipeDistance) <= swipeThreshold) return;

			if (swipeDistance > 0) {
				this.onPrevClick();
			} else {
				this.onNextClick();
			}
		},
	},
	components: {
		RunnitImage,
	},
});
